
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import ContactForm from "@/components/forms/ContactForm.vue";

@Component({
  components: {
    ContactForm,
  }
})
class Navigation extends Vue {
  isMobileMenuActive = false;

  modals = {
    contact: false,
  }

  get navigationItems() {
    return [
      {
        name: 'Drugi pogled',
        link: '/drugiPogled'
      },
      {
        name: 'O meni',
        link: '/oMeni'
      },
      {
        name: 'O Gestalt terapiji',
        link: '/oGestaltTerapiji'
      },
      {
        name: 'Usluge i cjenik',
        link: '/usluge'
      },
      {
        name: 'Suradnja',
        link: '/suradnja'
      },
      {
        name: 'Kontakt',
        link: '/kontakt'
      },
    ];
  }

  toggleMenu() {
    this.isMobileMenuActive = !this.isMobileMenuActive;
  }

  contact() {
    this.modals.contact = true;
  }
}

export default Navigation;
